<template>
  <a href="javascript:;" class="back" @click="toStorePage">
    <em class="back-ico"></em>
    <span class="back-text">{{ letter.backPay }}</span>
  </a>
</template>

<script>
import { mapGetters, mapState } from 'vuex'
import { GET_PRODUCT_LIST, CLEAR_PRODUCT_LIST } from '@store/officialStore'
export default {
  name: 'BackToStore',
  computed: {
    ...mapState({
      letter: state => state.letter,
      cartList: state => state.cart.cartList
    }),
    ...mapGetters(['gameInfoConfig'])
  },
  methods: {
    toStorePage() {
      this.$store.dispatch(CLEAR_PRODUCT_LIST)
      if (this.$store.state.serverId && this.$store.state.roleId) {
        this.$store.dispatch(GET_PRODUCT_LIST)
      }
      this.$router.push({ name: 'home' })
    }
  }
}
</script>

<style lang="scss" scoped>
.back {
  &-ico {
    display: inline-block;
    vertical-align: middle;
    cursor: pointer;
    @psetbg ('return.png');
  }
  &-text {
    margin-left: 8px;
    font-size: 24px;
    vertical-align: middle;
    color: #ffffff;
  }
}
</style>
